import type { UseBillingPeriodState } from './useBillingPeriod';

export interface BillingPeriodProps {
  billingPeriodState: UseBillingPeriodState;
}
export type BillingPeriodCoverageValues = {
  episodeStartDate: string;
  treatmentEpisode: string;
  payor: string;
  payorExternalId: string;
  equipPayor: string;
  equipPayorId: string;
  payorProgramName: string;
  endDate?: string;
  startDate: string;
  isAuthRequired: boolean;
};

export enum RenderMode {
  VIEW = 'view',
  EDIT = 'edit',
  CREATE = 'create',
}

export const SESSION_UNITS = [
  {
    label: 'Days',
  },
  {
    label: 'Weeks',
  },
  {
    label: 'Months',
  },
];
export const STATUS = [
  {
    label: 'Approved',
  },
  {
    label: 'Pending',
  },
  {
    label: 'Denied',
  },
];
